// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__OfqKV","buttons":"SendReceipts_buttons__AzjbS","email":"SendReceipts_email__3MTzW","bookApptTitle":"SendReceipts_bookApptTitle__242o7"};